<section id="signalbot" class="signalbot-teaser">
  <div class="teaser__content">
    <h2>{{ 'SIGNALBOT_TEASER.TITLE' | translate }}</h2>
    <p [innerHTML]="'SIGNALBOT_TEASER.DESCRIPTION' | translate"></p>
    <a routerLink="/signalbot" class="cta-button">{{ 'SIGNALBOT_TEASER.BUTTON' | translate }}</a>
  </div>
</section>
